<div class="flex-column h-100">
  <div class="configuration-wizard-header">
    <h5
      class="odx-title-5"
      i18n="@@centralStationConfiguration.quantitySelector.header"
      data-testid="centralStationConfiguration.quantitySelector.header"
    >
      {{ title() }}
    </h5>
    <app-filter-product (searchEvent)="search($event)" />
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @for (section of sections(); track $index) {
      @if (section.options.length > 0) {
        @if (section.header) {
          <h6 class="odx-title-6 section-title">{{ section.header }}</h6>
        }
        <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
          @for (option of section.options; track trackOption(option)) {
            <app-monitoring-option-card-with-quantity
              [optionData]="option"
              [quantity]="getSelectedQuantity(option.option)"
              [minValue]="option.option.quantityMin"
              [maxValue]="option.option.quantityMax"
              [selectionMode]="StepSelectionType.PICK0TON"
              [category]="category()"
              [categoryLabel]="categoryLabel()"
              (quantityChanged)="updateSelectedQuantity($event, option.option)"
              (select$)="toggleOption($event, option.option)"
            />
          }
        </div>
      }
    }
  </odx-content-box>
</div>
